import { loaderKind, SET_LOADER } from "../actions/types";

const initialState = {
  pagePending: 0,
  gridPending: 0,
  isLoading: false,
  isGridLoading: false,
};

const counterFor = (kind) =>
  kind === loaderKind.GRID ? "gridPending" : "pagePending";

/**
 * Two reference counted buckets:
 *
 *  - "page" drives the blocking page indicator (default, so every existing
 *    dispatch keeps working unchanged)
 *  - "grid" drives the quiet in-table progress bar of a data grid refetch
 *
 * Counted rather than boolean so overlapping requests cannot switch each other
 * off - a grid refetch finishing must not dismiss a slow document operation.
 */
const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER: {
      const counter = counterFor(action.meta?.loader);
      // guard against a rehydrated state from before the counters existed -
      // undefined + 1 is NaN, which would disable the indicator for the session
      const current = Number.isFinite(state[counter]) ? state[counter] : 0;
      const pending = Math.max(0, current + (action.payload ? 1 : -1));

      const next = { ...state, [counter]: pending };

      return {
        ...next,
        isLoading: next.pagePending > 0,
        isGridLoading: next.gridPending > 0,
      };
    }
    default:
      return state;
  }
};

export default loaderReducer;
